import * as React from 'react';
import Callback from '../Callback/CallbackSpinner';
// @ts-ignore
import queryString from 'query-string';
import {RouteChildrenProps} from 'react-router-dom';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {signinUserWithExternalService} from '../../actions';

interface Props extends RouteChildrenProps {
    provider: string;
    signinUserWithExternalService: Function; // TODO: typing for function
}

const ExternalServiceCallback: React.FunctionComponent<Props> =
    ({history, provider, signinUserWithExternalService, location}) => {
        React.useEffect(() => { // Equal to componentDidMount
            // @ts-ignore
            const queryParams = queryString.parse(location.search, {ignoreQueryPrefix: true});
            signinUserWithExternalService({
                code: queryParams.code,
                state: queryParams.state,
                history: history,
                provider: provider,
            });
        }, []);

        return <Callback />;
    };

export default compose(connect(null, {signinUserWithExternalService}))(ExternalServiceCallback);